import React from "react";
import { Box, TextField, Typography } from "@mui/material";

import {
  ELIGIBLE_COUNT_WARNING_THRESHOLD,
  GUID_TEXTAREA_PLACEHOLDER,
} from "../consts";
import { CountBox } from "./CountBox";
import { InfoAlert } from "./Alerts";
import { RecalculationStatusAlerts } from "./RecalculationStatusAlerts";

interface GuidModeTabProps {
  guidsText: string;
  onGuidsTextChange: (value: string) => void;
  eligibleCount: number | null;
  isCountLoading: boolean;
  isJobRunning: boolean;
}

export const GuidModeTab = ({
  guidsText,
  onGuidsTextChange,
  eligibleCount,
  isCountLoading,
  isJobRunning,
}: GuidModeTabProps) => {
  const isWarning =
    !isCountLoading && (eligibleCount ?? 0) > ELIGIBLE_COUNT_WARNING_THRESHOLD;

  return (
    <Box sx={{ pt: "6px" }}>
      <TextField
        multiline
        fullWidth
        minRows={7}
        maxRows={11}
        placeholder={GUID_TEXTAREA_PLACEHOLDER}
        value={guidsText}
        onChange={(event) => onGuidsTextChange(event.target.value)}
        inputProps={{ "aria-label": "GUIDs, one per line" }}
        sx={{
          "& .MuiInputBase-root": {
            fontFamily: "monospace",
            fontSize: "12px",
            alignItems: "flex-start",
          },
          "& textarea": {
            resize: "none",
            minHeight: "160px",
            maxHeight: "200px",
            overflowY: "auto",
          },
        }}
      />
      <Typography
        sx={{ fontSize: "11px", color: "#8aa0a0", mt: "6px", mb: 1.75 }}
      >
        One GUID per line
      </Typography>

      <CountBox
        label="Eligible Bills"
        sublabel="Matching submitted GUIDs"
        count={eligibleCount}
        isLoading={isCountLoading}
        isWarning={isWarning}
      />

      <RecalculationStatusAlerts
        isJobRunning={isJobRunning}
        isWarning={isWarning}
        infoAlert={
          <InfoAlert>
            Emissions will be recalculated for all valid eligible GUIDs.{" "}
            <strong>This action cannot be undone.</strong>
          </InfoAlert>
        }
      />
    </Box>
  );
};
